import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { ApiService } from 'src/app/providers/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sm-add-edit-online-payment',
  templateUrl: './add-edit-online-payment.component.html',
  styleUrls: ['./add-edit-online-payment.component.scss']
})
export class AddEditOnlinePaymentComponent implements OnInit {

  private _apiSubscription: Subscription = new Subscription();
  onlinePaymentsObj: any = {
    hashId: '',
    email: null,
    bank_name: null,
    branch_name: null,
    account_number: null,
    account_holder_name: null,
    ifsc_code: null,
    pan_card_number: null,
    accountType: 0,
    refund_period: 5
    
  }
  constructor(@Inject(MAT_DIALOG_DATA) public parentData: any, private loaderservice: LoaderServiceService, private _apiservice: ApiService) { }

  ngOnInit(): void {
    let data = this.parentData.data
    console.log(data);
    
    this.onlinePaymentsObj.hashId = data.hashId 
    this.onlinePaymentsObj.email = data.email 
    this.onlinePaymentsObj.bank_name = data.bank_name 
    this.onlinePaymentsObj.branch_name = data.branch_name
    this.onlinePaymentsObj.account_number = data.account_number 
    this.onlinePaymentsObj.account_holder_name = data.account_holder_name
    this.onlinePaymentsObj.ifsc_code = data.ifsc_code
    this.onlinePaymentsObj.pan_card_number = data.pan_card_number 
    this.onlinePaymentsObj.accountType = data.account_type ? data.account_type : 0
    this.onlinePaymentsObj.refund_period = data.refund_period ? data.refund_period : 7

    this._apiSubscription = this._apiservice.apiResult.subscribe((resData) => {
      if(resData.responseType === SM_CONSTANTS.UPDATE_BANK_INFO_RESULT){

        this.parentData.ref.closeAll();
      }
    })

  }

  onToggleChangeOtherDiscount(event:any){
    
    if(event.checked){
      this.onlinePaymentsObj.otherDiscounts = 1
    }else if(!event.checked){
      this.onlinePaymentsObj.otherDiscounts = 0

      
    }
  }

  onSubmitDiscountDetails(){

    let data = JSON.parse(JSON.stringify(this.onlinePaymentsObj))


    data.created_by = data.edited_by = localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
    data.business_hash_id = this.parentData.data.business_hash_id
    data.isEdit = this.parentData.isEdit
    Object.keys(data).forEach(key => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });

    data.business_name = localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_NAME)
    data.business_type = "individual"
    console.log(data);

    this.loaderservice.showLoader = true
    this._apiservice.updateBankInfo(data)
  }

}

